module.exports = __webpack_public_path__ + "static/img/braun_wecker.f6bdd51.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/braun_wecker.gif
// module id = 291
// module chunks = 0